import { Box, Row, Typography } from '@tempmee/react';
import { OutlineXIcon } from '@tempmee/react-icons';
import { colors } from '@tempmee/tailwind';
import { IInputInviteCandidateValue } from '../../InviteCandidate/components/InputInviteCandidate/Types';

interface ISelectedCandidatesListProps {
  candidates: IInputInviteCandidateValue[];
  onRemove: (value: string) => void;
}

/**
 * Shows the candidates currently selected for the interview invite as
 * removable pills. Mirrors the shift-request invite pill style
 * (InvitedProfessionalPill) — each pill has a trailing close icon to remove it.
 */
export const SelectedCandidatesList = ({ candidates, onRemove }: ISelectedCandidatesListProps) => {
  if (candidates.length === 0) return null;

  return (
    <Row wrap="wrap" gap={2}>
      {candidates.map((candidate) => (
        <Row
          key={candidate.value}
          align="center"
          gap={1}
          data-testid={`selected-candidate-pill.${candidate.value}`}
          data-cy="selected-candidate-pill"
          style={{
            border: `1.5px solid ${colors.secondary[500]}`,
            backgroundColor: colors.primary[50],
            borderRadius: 24,
            display: 'inline-flex',
            height: 38,
            paddingLeft: 14,
            paddingRight: 14,
          }}
        >
          <Typography
            size="body_small"
            color={colors.neutral[600]}
            numberOfLines={1}
            style={{ minWidth: 0 }}
          >
            {candidate.label}
          </Typography>
          <Box
            role="button"
            data-testid={`remove-candidate.${candidate.value}`}
            data-cy="remove-candidate"
            style={{
              cursor: 'pointer',
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              marginLeft: 4,
            }}
            onClick={() => onRemove(candidate.value)}
          >
            <OutlineXIcon size={24} color={colors.secondary[500]} />
          </Box>
        </Row>
      ))}
    </Row>
  );
};
